import Vue from "vue";
import VueRouter from "vue-router";
import { clearPending } from "@/utils/request";

import DashRoot from "@/views/dash/index.vue";
import DashShell from "@/views/dash/Shell.vue";

const Overview = () => import("@/views/dash/pages/Overview.vue");
const Thought = () => import("@/views/dash/pages/Thought.vue");
const Org = () => import("@/views/dash/pages/Org.vue");
const Duty = () => import("@/views/dash/pages/Duty.vue");
const Activity = () => import("@/views/dash/pages/Activity.vue");
const Mechanism = () => import("@/views/dash/pages/Mechanism.vue");
const MechanismNew = () => import("@/views/dash/pages/MechanismNew.vue");
const Branch = () => import("@/views/dash/pages/Branch.vue");

const NotFound = () => import("@/views/errorPage/404.vue");

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: DashRoot,
    children: [
      {
        path: "",
        component: DashShell,
        children: [
          { path: "", redirect: "overview" },
          {
            path: "overview",
            component: Overview,
            meta: { title: "全域总览" }
          },
          {
            path: "thought",
            component: Thought,
            meta: { title: "思想引领" }
          },
          {
            path: "org",
            component: Org,
            meta: { title: "组织建设" }
          },
          {
            path: "duty",
            component: Duty,
            meta: { title: "履职建言" }
          },
          {
            path: "activity",
            component: Activity,
            meta: { title: "活动公益成果" }
          },
          {
            path: "mechanism",
            component: Mechanism,
            meta: { title: "机制创新" }
          },
          {
            path: "mechanismNew",
            component: MechanismNew,
            meta: { title: "机制创新" }
          },
          {
            path: "branch",
            component: Branch,
            meta: { title: "分会数据" }
          }
        ]
      }
    ]
  },
  {
    path: "/404",
    component: NotFound
  },
  {
    path: "*",
    redirect: "/404"
  }
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },
  routes
});

router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.title) {
    document.title = to.meta.title + " · 新联会数字大屏";
  }
  clearPending();
  next();
});

export default router;
